import { css } from 'styled-components';

export const leftAlignedTextStyles = css`
  text-align: left;
`;
